import * as c from '@chakra-ui/react'
import React from 'react'
import { useProperties } from 'src/hooks/properties'
import { ApartmentCard } from 'src/pages/home-v2/components/apartment-banners/apartment-card'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import Carousel from '../carousel'
import Filter from './filter'

interface ApartamentsProps {
  apartamentsBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    idSection?: string
  }
  data: ListItem[]
}

export interface ListItem {
  active: boolean
  carrousel?: boolean
  list: { orderShow: number; _id: string; housiId: string }[]
  category: string
  name: string
  type: string
  _id: string
}

export default function Apartaments({
  apartamentsBanner,
  data,
}: ApartamentsProps) {
  const [tabIndex, setTabIndex] = React.useState<number>(0)
  const propertiesList = data?.filter(
    (item) => item.carrousel && item.list.length > 0
  ) as ListItem[]

  const handleTabsChange = (index: number) => setTabIndex(index)

  return (
    <c.Container px={['s5', 0]} id={apartamentsBanner?.idSection}>
      <c.Tabs index={tabIndex} onChange={handleTabsChange}>
        <c.Flex
          mb="l2"
          direction={['column', 'row']}
          justify="space-between"
          gap="m4"
        >
          <c.Flex direction="column" gap="s2">
            <c.Heading size="md">
              {translateText(apartamentsBanner?.title)}
            </c.Heading>
            <c.Text fontSize="t-md.1">
              {translateText(apartamentsBanner?.subtitle)}
            </c.Text>
          </c.Flex>
          <Filter data={propertiesList} index={tabIndex} />
        </c.Flex>

        <c.TabPanels>
          {propertiesList?.map((item) => (
            <c.TabPanel key={item._id}>
              <CarouselList
                list={item?.list?.map((a) => a.housiId).slice(0, 9)}
                key={item._id}
              />
            </c.TabPanel>
          ))}
        </c.TabPanels>
      </c.Tabs>
    </c.Container>
  )
}

function CarouselList({ list }) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')
  const slidesPerView = isMobile ? 1.2 : 3.2
  const { apartments: properties, apartmentLoading } = useProperties({
    apartmentIds: list,
    fetchList: true,
  })

  if (apartmentLoading) return <Loading isMobile={isMobile} />

  return (
    <React.Suspense fallback={<Loading isMobile={isMobile} />}>
      <Carousel
        data={properties}
        Content={Content}
        slidesPerView={slidesPerView}
      />
    </React.Suspense>
  )
}

function Content({ data }: { data: ListItem }) {
  return <ApartmentCard property={data} />
}

function Loading({ isMobile }: { isMobile: boolean }) {
  if (isMobile)
    return (
      <c.Flex w="full" gap="s2">
        <c.Skeleton w="329px" h="259px" borderRadius="20px" />
        <c.Skeleton w="89px" h="259px" borderRadius="20px 0 0 20px" />
      </c.Flex>
    )

  return (
    <c.Flex w="full" gap="s4">
      <c.Skeleton h="259px" w="366px" borderRadius="20px" />
      <c.Skeleton h="259px" w="366px" borderRadius="20px" />
      <c.Skeleton h="259px" w="366px" borderRadius="20px" />
      <c.Skeleton h="259px" w="183px" borderRadius="20px 0 0 20px" />
    </c.Flex>
  )
}
